export default [
  {
    path:"/birth",
    name:"Birth-list",
    component: () => import("@/components/adm/birth/BirthList.vue"),
    meta: {
      title: "Controle Leiteiro > Controle de Parto"
    }
  },
]